import * as React from 'react';
import { ReportType } from '../../../enums';
import { PVAContentHeader, PVAContentBody, LoadingIndicator, PVACharacteristicSelect } from '../../../components';
import { ReportDataService, CharacteristicDataService, CharacteristicGroupDataService, TeamDataService } from '../../../services';
import { User, Team, CharacteristicGroup, Characteristic } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { UserStore, FilterStore } from '../../../stores';
import '../teamListView/TeamListView.css';

interface TeamListViewRIReportState {
    orgId: number;
    surveyVersionId: number;
    selectedUserData: any[];
    teams: Team[];
    team: Team | undefined;
    usersToFocus: (User | undefined)[];
    reportType: ReportType;
    characteristicGroups: CharacteristicGroup[];
    characteristics: Characteristic[];
    selectedCharacteristic: Characteristic[];
    loading: boolean;
    teamId: number | undefined;
    characteristicId: number[];
    used: boolean[];
}

interface TeamListViewRIReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class TeamListViewRIReport extends React.Component<TeamListViewRIReportProps, TeamListViewRIReportState> {
    private reportDataService = new ReportDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private teamDataService = new TeamDataService(this.props.notificationService);

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get team() {
        if (this.props.FilterStore && this.props.FilterStore.team) {
            return this.props.FilterStore.team;
        }
        return null;
    }

    @computed get teamName() {
        return this.props.FilterStore!.teamName;
    }
    
    @computed get teamId() {
        return this.props.FilterStore && this.props.FilterStore.teamId;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    constructor(props: TeamListViewRIReportProps) {
        super(props);

        this.state = {
            selectedUserData: [],
            usersToFocus: [undefined, undefined, undefined, undefined],
            characteristicGroups: [],
            characteristics: [],
            reportType: ReportType.Standard,
            orgId: 0,
            surveyVersionId: 0,
            teamId: -1,
            selectedCharacteristic: [],
            teams: [],
            team: undefined,
            loading: true,
            characteristicId: [ 0, 0, 0, 0 ],
            used: [false, false, false, false]
        };
    }

    private updateTeam() {
        if (this.surveyVersion && this.organization) {
            // var surveyId = this.survey.id;
            this.setState({
                selectedUserData: [],
                loading: true
            });

            var data: any[] = [];

            if (this.teamId && this.teamId !== this.state.teamId) {
                this.setState({
                    teamId: this.teamId
                });
                if (this.teamId === -100) {
                    // all users
                    this.reportDataService.getTeamListViewReportByOrganization(this.surveyVersion.id, this.organization.id).then((reportData: any) => {
                        reportData.teamListViewUserResults.map((userData: any) => {
                            data.push(userData);
                        });
                        this.setState({
                            selectedUserData: data,
                            loading: false
                        });
                    });
                } else if (this.teamId === -200) {
                    // all users
                    this.reportDataService.getTeamListViewReportByCandidates(this.surveyVersion.id, this.organization.id).then((reportData: any) => {
                        reportData.teamListViewUserResults.map((userData: any) => {
                            data.push(userData);
                        });
                        this.setState({
                            selectedUserData: data,
                            loading: false
                        });
                    });
                } else if (this.teamId === -300) {
                    // all users
                    this.reportDataService.getTeamListViewReportByFormer(this.surveyVersion.id, this.organization.id).then((reportData: any) => {
                        reportData.teamListViewUserResults.map((userData: any) => {
                            data.push(userData);
                        });
                        this.setState({
                            selectedUserData: data,
                            loading: false
                        });
                    });
                } else {
                    this.reportDataService.getTeamListViewReportByTeam(this.surveyVersion.id, this.teamId).then((reportData: any) => {
                        reportData.teamListViewUserResults.map((userData: any) => {
                            data.push(userData);
                        });
                        this.setState({
                            selectedUserData: data,
                            loading: false
                        });
                    });
                }
            } else {
                this.setState({
                    selectedUserData: [],
                    loading: false,
                    teamId: 0
                });
            }
        }
    }

    private update() {
        if (this.userRole !== 'user') {
            if (this.organization && this.organization.id !== this.state.orgId) {
                this.setState({
                    orgId: this.organization.id,
                    selectedUserData: [],
                    loading: true
                });

                this.teamDataService.getByOrganization(this.organization).then((teams: Team[]) => {

                    this.setState({
                        teams: teams,
                        team: teams[0],
                        usersToFocus: [undefined, undefined, undefined, undefined],
                        loading: false
                    });
                    
                    this.updateTeam();

                    // if (this.organization) {
                    //     this.userDataService.getByOrganizationLight(this.organization.id).then((users: User[]) => {
                    //         this.setState({
                    //             users: users,
                    //             loading: false
                    //         });
                    //         this.updateTeam();
                    //     });
                    // }
                });
            }

            if (this.surveyVersion && this.surveyVersion.id !== this.state.surveyVersionId) {
                this.setState({
                    surveyVersionId: this.surveyVersion.id
                });

                this.characteristicGroupDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                    this.setState({
                        characteristicGroups: characteristicGroups
                    });
                });

                this.characteristicDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristics: Characteristic[]) => {
                    characteristics = characteristics.sort((a: Characteristic, b: Characteristic) => {
                        if (a.name > b.name) {
                            return 1;
                        } else if (a.name < b.name) {
                            return -1;
                        }
                        return 0;
                    });
                    this.setState({
                        characteristics: characteristics
                    });
                });

            }

            if (this.teamId && this.teamId !== this.state.teamId) {
                this.updateTeam();
            } else if (this.teamId !== this.state.teamId) {
                this.setState({
                    teamId: this.teamId,
                    selectedUserData: []
                });
            }
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    public charactersticChange(e: any, ind: number) {
        var chars = this.state.characteristicId;
        chars[ind] = Number(e.target.value);
        this.setState({
            characteristicId: chars
        });
    }

    private GetKeyOverride(key?: string, fallback?: any) {
        if (key && this.props.FilterStore) {
            return this.props.FilterStore.GetKeyOverride(key, fallback || '');
        }
        return fallback;
    }

    public render() {

        return (
            <div className="team-totem-pole-report">
                {this.team && <div id={`team-${this.team.id}`} />}
                {this.teamId && <div id={`team-id-${this.teamId}`} />}
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}

                <PVAContentHeader>
                    <div className="title">
                        {this.GetKeyOverride('teamListViewReportRI', <span>PVA Team List View RI<span className="trademark">TM</span></span>)}
                        <span className="light"> for </span> '{this.teamName}'
                    </div>
                </PVAContentHeader>

                <div className="team-totem-pole-header">
                    <div className="row">
                        {
                            [0, 1, 2, 3].map((ind: number) => {
                                return <div key={`header-${ind}`} className="col-xs-3">
                                    <span>{this.state.characteristicId[ind]}</span>
                                    <PVACharacteristicSelect options={this.state.characteristics} groups={this.state.characteristicGroups} selected={this.state.characteristicId[ind]} onChange={(e: any) => this.charactersticChange(e, ind)} responseIndicator={true} />
                                </div>;
                            })
                        }
                    </div>
                </div>
                
                <PVAContentBody>
                    {this.state.loading && <LoadingIndicator />}
                    {!this.state.loading && <div className="row">
                        {
                            [0, 1, 2, 3].map((ind: number) => {
                                return <div key={`block-${ind}`} className="col-xs-3">
                                    <ul className="pva-user-list">
                                        {
                                            this.state.characteristicId[ind] !== 0 && 
                                            this.getAllUsers(this.state.characteristicId[ind]).map((x: any, userInd: number) => {
                                                var cls = '';
                                                if (x.focusIndex > -1) {
                                                    cls = 'selected-' + ['one', 'two', 'three'][x.focusIndex];
                                                }

                                                return <li className={cls} key={`user-${userInd}`} onClick={(e) => x.focusIndex > -1 ? this.unfocusUser(x.userID) : this.focusUser(x.userID)}>
                                                    <div className="row hidden-xs">
                                                        <div className="col-xs-8">
                                                            <div className="name">
                                                                {x.displayName ? x.displayName : x.name}
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-4 text-right">
                                                            <div className="percentage">
                                                                {Math.round(x.characteristic.score)}%
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="visible-xs">
                                                        {x.name} {Math.round(x.characteristic.score)}%
                                                    </div>
                                                </li>;
                                            })
                                        }
                                    </ul>
                                </div>;
                            })
                        }
                    </div>}
                </PVAContentBody>
            </div>);
    }

    private unfocusUser(userId: number) {
        var userInd = this.state.usersToFocus.findIndex((value: User) => {
            if (value !== undefined && value.id === userId) {
                return true;
            }
            return false;
        });

        if (userInd > -1) {
            var u = this.state.usersToFocus;
            u[userInd] = undefined;
            this.setState(
                {
                    usersToFocus: u
                }, 
                this.forceUpdate);
        }
    }

    private focusUser(userId: number) {
        var user = this.users.find((value: User, ind: Number) => {
            if (value.id === userId) {
                return true;
            }
            return false;
        });

        for (var i = 0; i < 4; i++) {
            if (this.state.usersToFocus[i] === undefined) {
                var u = this.state.usersToFocus;
                u[i] = user;
                this.setState(
                    {
                        usersToFocus: u
                    }, 
                    this.forceUpdate);
                break;
            }
        }
        this.forceUpdate();
    }

    private getAllUsers(charId: number) {

        var result: any[] = [];

        this.state.selectedUserData.map((data: any) => {

            var characteristic: any = null;

            characteristic = data.entries.find((d: any) => {
                return Number(d.characteristicID) === charId || Number(d.previousCharacteristicID) === charId;
            });

            if (!characteristic) {
                characteristic = {
                    score: 0
                };
            }
        
            result.push({
                name: data.lastName + ', ' + data.firstName,
                characteristic: characteristic,
                focusIndex: this.state.usersToFocus.findIndex((u: User) => { return u !== undefined && u.id === Number(data.userID); }),
                userID: Number(data.userID)
            });
        });

        result.sort((a: any, b: any) => {
            if (a.characteristic.score > b.characteristic.score) {
                return -1;
            }
            if (a.characteristic.score < b.characteristic.score) {
                return 1;
            }
            return 0;
        });
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/teamListViewRI/TeamListViewRIReport.tsx